import { ProductDigitalData } from '@dustin-web/product-components/src/utils/product-digital-data'
import { storeCartDetails } from '@dustin-web/product-components/src/utils/cart-local-storage'
import { DigitalDataOrigin } from '@dustin-web/product-components/src/utils/digital-data-types'
import { CartBaseProduct } from '@dustin-web/product-components/src/hooks/cart/cart-base-product-types'

type EventData = {
  event: 'addToCart' | 'removeFromCart'
  product: CartBaseProduct
  oldQuantity: number
  newQuantity: number
  digitalDataIndex: number
  digitalDataOrigin: DigitalDataOrigin
  translate: (key: string) => string
  currencyCode: string
}

export const pushEvent = (data: EventData) => {
  if (!data.product) return

  const quantityDiff =
    data.event === 'addToCart'
      ? data.newQuantity - data.oldQuantity
      : data.oldQuantity - data.newQuantity

  if (quantityDiff !== 0) {
    if (data.event === 'addToCart') {
      ProductDigitalData.pushAddToCart(
        [{ ...data.product, productListIndex: data.digitalDataIndex }],
        quantityDiff,
        data.translate,
        data.digitalDataOrigin,
        'plusSign'
      )
    } else {
      storeCartDetails({
        action: 'REMOVE',
        productErp: data.product.productErpIdentifier,
        newQuantity: data.newQuantity,
      })
      ProductDigitalData.pushRemoveFromCart(
        [{ ...data.product, quantity: quantityDiff }],
        quantityDiff,
        data.translate,
        data.currencyCode,
        data.product.price!.priceExcludingVat * quantityDiff,
        data.digitalDataOrigin
      )
    }
  }
}
